import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { ProductInfoHolder } from './product-info-holder';

@Injectable({
  providedIn: 'root',
})
export class PriceCheckerService {
  readonly serviceURL: string;
  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/prices';
  }

  getPrices(skus: string[]): Observable<ProductInfoHolder> {
    return this.http.post<ProductInfoHolder>(this.serviceURL, {
      skus,
    });
  }
}
